interface SelectionBarProps {
  count: number;
  onDelete: () => void;
  onMove: () => void;
  onExit: () => void; // clears selection AND exits selection mode
}

export function SelectionBar({ count, onDelete, onMove, onExit }: SelectionBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-brand-700 bg-brand-900/30 px-4 py-2 text-sm">
      <span className="text-brand-300 font-medium">
        {count} item{count !== 1 ? "s" : ""} selected
      </span>
      <div className="ml-auto flex items-center gap-2">
        {count > 0 && (
          <>
            <button
              type="button"
              onClick={onMove}
              className="rounded px-3 py-1 text-brand-300 hover:bg-brand-900/50 transition-colors"
            >
              Move
            </button>
            <button
              type="button"
              onClick={onDelete}
              className="rounded px-3 py-1 text-red-400 hover:bg-red-900/30 transition-colors"
            >
              Delete
            </button>
          </>
        )}
        <button
          onClick={onExit}
          className="rounded px-3 py-1 text-gray-400 hover:bg-gray-800 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
